import { formattedLastActivityDateBetween } from ".";
import { AssignmentFilterData } from "../workflows/assignment/AssignmentFilterPopover";
import { AssignmentData } from "../workflows/assignment/models";

// ASSIGNMENT

export const filterDataByKey = (
  data: AssignmentData[],
  filteredKeys: { [key: string]: AssignmentFilterData[] } | undefined,
  key: string
) => {
  let filteredData = [...data];

  switch (key) {
    case "email":
      if (filteredKeys?.[key]?.length) {
        filteredData = filteredData.filter((d) =>
          (filteredKeys[key] || []).some((k) => k.key === d.actor_uuid)
        );
      }
      break;

    case "lastActive":
      if (filteredKeys?.[key]?.length) {
        filteredData = filteredData.filter((d) =>
          (filteredKeys[key] || []).some((k) => {
            if (
              (formattedLastActivityDateBetween(k.label) === ">45" &&
                formattedLastActivityDateBetween(d.lastActive ?? "") ===
                  ">45") ||
              (formattedLastActivityDateBetween(k.label) === "" &&
                formattedLastActivityDateBetween(d.lastActive ?? "") === "")
            ) {
              return true;
            }
            return k.label === (d.lastActive ?? "");
          })
        );
      }
      break;

    case "lastTask":
      if (filteredKeys?.[key]?.length) {
        filteredData = filteredData.filter((d) =>
          (filteredKeys[key] || []).some((k) => k.label === d.lastTask)
        );
      }
      break;

    default:
      const stepKeys = Object.keys(filteredKeys || {});
      const stepKeysWithFilter = stepKeys.filter(
        (sk) => filteredKeys?.[sk]?.length
      );
      if (stepKeysWithFilter.length) {
        filteredData = filteredData.filter((d) => {
          return stepKeysWithFilter.some((sk) => {
            const checkOptions = filteredKeys?.[sk]?.map((k) => k.label) ?? [];
            const isAssigned = d.tasks.some((t) => t.key === sk)
              ? "assigned"
              : "unassigned";

            return checkOptions.includes(isAssigned);
          });
        });
      }

      break;
  }

  return filteredData;
};
